module.exports = __webpack_public_path__ + "static/media/logo-white.84b76a40.svg";